import { type CSSProperties, type MouseEvent, useMemo, useState } from 'react';

type Props = {
  blocks: FeedbackBlockT[];
};

const useFeedbackBlockTooltip = (props: Props) => {
  const [tooltipInfo, setTooltipInfo] = useState<{
    blockId?: string;
    pos?: CSSProperties;
    status: boolean;
  }>({
    status: false,
  });

  const currentBlockInfo = useMemo(() => {
    const block = props.blocks.find(
      (block) => block.alias === tooltipInfo?.blockId,
    );
    if (!block) return null;
    return block;
  }, [tooltipInfo?.blockId, props.blocks]);

  const onMouseMove = (e: MouseEvent) => {
    const target = e.target as HTMLDivElement;
    const anchor = target.querySelector('.tooltip-anchor');
    const blockId = target.dataset.blockId;
    if (!anchor) {
      setTooltipInfo((prev) => ({
        ...prev,
        status: false,
      }));
      return;
    }
    const rect = anchor.getBoundingClientRect();

    const getLeftOffset = () => {
      if (window.innerWidth - (rect.left + 200) > 0) return rect.left - 8;
      return window.innerWidth - 200 - 8;
    };

    setTooltipInfo((prev) => {
      if (!blockId)
        return {
          ...prev,
          status: false,
        };
      return {
        blockId,
        pos: {
          left: getLeftOffset(),
          top: rect.top - 8,
          transform: 'translate(0, -100%)',
        },
        status: true,
      };
    });
  };

  const onMouseLeave = () =>
    setTooltipInfo((prev) => ({
      ...prev,
      status: false,
    }));

  return {
    tooltipInfo,
    onMouseMove,
    onMouseLeave,
    currentBlockInfo,
  };
};

export default useFeedbackBlockTooltip;
